export interface QueueLandingPayload {
    key1: string;
    key2: string;
}

export const queueLandingBase64ToPayload = (
    base64: string
): QueueLandingPayload | null => {
    try {
        const payload = atob(base64);
        const parsedPayload = JSON.parse(payload);
        if (typeof parsedPayload !== "object") {
            throw new Error("Invalid payload");
        }

        if (!("key1" in parsedPayload) || !("key2" in parsedPayload)) {
            throw new Error("Invalid payload");
        }

        return parsedPayload as QueueLandingPayload;
    } catch {
        return null;
    }
};

/*******************************************************************
 * This is used for the Join Queue Landing page at route /join-queue
 *******************************************************************/
export interface JoinQueueLandingPayload {
    key1: string;
    key2: string;
}

export const joinQueueLandingBase64ToPayload = (
    base64: string
): JoinQueueLandingPayload | null => {
    try {
        const payload = atob(base64);
        const parsedPayload = JSON.parse(payload);

        if (typeof parsedPayload !== "object") {
            throw new Error("This payload is not valid");
        }

        if (!("key1" in parsedPayload) || !("key2" in parsedPayload)) {
            throw new Error("This payload is missing required fields");
        }

        return parsedPayload;
    } catch {
        return null;
    }
};

/**
 * Referral landing payload
 */
export interface ReferralLandingPayload {
    organizationName: string;
    patientName: string;
    therapyCategoryName: string;
    key1: string;
    key2: string;
}

export const referralLandingBase64ToPayload = (
    base64: string
): ReferralLandingPayload | null => {
    try {
        const payload = atob(base64);
        const parsedPayload = JSON.parse(payload);
        if (typeof parsedPayload !== "object") {
            throw new Error("Invalid payload");
        }

        if (
            !("key1" in parsedPayload) ||
            !("key2" in parsedPayload) ||
            !("organizationName" in parsedPayload) ||
            !("patientName" in parsedPayload) ||
            !("therapyCategoryName" in parsedPayload)
        ) {
            throw new Error("Invalid payload");
        }

        return parsedPayload as ReferralLandingPayload;
    } catch {
        return null;
    }
};

/*******************************************************************
 * This is used for unsubscribing from a single email preference type
 *******************************************************************/
export interface UnsubscribeEmailPayload {
    key1: string;
    key2: string;
}

export const unsubscribeEmailBase64ToPayload = (
    base64: string
): UnsubscribeEmailPayload | null => {
    try {
        const payload = atob(base64);
        const parsedPayload = JSON.parse(payload);

        if (typeof parsedPayload !== "object") {
            throw new Error("This payload is not valid");
        }

        if (!("key1" in parsedPayload) || !("key2" in parsedPayload)) {
            throw new Error("This payload is missing required fields");
        }

        return parsedPayload;
    } catch {
        return null;
    }
};

/*******************************************************************
 * This is used for the Upload Files public page at route /upload-files
 *******************************************************************/
export interface UploadFilesPublicPayload {
    organizationName: string;
    key1: string;
    key2: string;
}

export const uploadFilesPublicBase64ToPayload = (
    base64: string
): UploadFilesPublicPayload | null => {
    try {
        const payload = atob(base64);
        const parsedPayload = JSON.parse(payload);

        if (typeof parsedPayload !== "object") {
            throw new Error("This payload is not valid");
        }

        if (
            !("key1" in parsedPayload) ||
            !("key2" in parsedPayload) ||
            !("organizationName" in parsedPayload)
        ) {
            throw new Error("This payload is missing required fields");
        }

        return parsedPayload as UploadFilesPublicPayload;
    } catch {
        return null;
    }
};
